export interface SitemapPathNode {
  id: string;
  customUrl: string | null;
  children: SitemapPathNode[];
}

export interface AppSitemapPathNode extends SitemapPathNode {
  entityName: string | null;
  children: AppSitemapPathNode[];
}

/** 找到当前 URL 最具体的菜单路径；精确匹配优先，避免父级 URL 前缀抢占三级菜单。 */
export function findBestSitemapPath(
  nodes: SitemapPathNode[],
  pathname: string,
): SitemapPathNode[] | null {
  let bestPath: SitemapPathNode[] | null = null;
  let bestScore = 0;
  const visit = (items: SitemapPathNode[], ancestors: SitemapPathNode[]) => {
    for (const node of items) {
      const path = [...ancestors, node];
      const score = urlScore(node.customUrl, pathname);
      if (score > bestScore) {
        bestPath = path;
        bestScore = score;
      }
      if (node.children.length) visit(node.children, path);
    }
  };
  visit(nodes, []);
  return bestPath;
}

function urlScore(customUrl: string | null, pathname: string): number {
  if (!customUrl) return 0;
  if (pathname === customUrl) return 100_000 + customUrl.length;
  return pathname.startsWith(`${customUrl}/`) ? customUrl.length : 0;
}

/**
 * 匹配应用内当前路由对应的菜单路径。实体路由优先于父级自定义 URL 的前缀，
 * 精确的自定义页面仍优先于实体匹配。
 */
export function findBestAppSitemapPath(
  nodes: AppSitemapPathNode[],
  pathname: string,
  search = '',
): AppSitemapPathNode[] | null {
  const entitySlug = pathname.match(/\/app\/[^/]+\/([^/]+)/)?.[1];
  const currentPathWithSearch = `${pathname}${search}`;
  let bestPath: AppSitemapPathNode[] | null = null;
  let bestScore = 0;

  const visit = (items: AppSitemapPathNode[], ancestors: AppSitemapPathNode[]) => {
    for (const node of items) {
      const path = [...ancestors, node];
      const customScore = (() => {
        if (!node.customUrl) return 0;
        if (currentPathWithSearch === node.customUrl) return 1000 + node.customUrl.length;
        if (pathname === node.customUrl) return 800 + node.customUrl.length;
        if (!node.customUrl.includes('?') && pathname.startsWith(`${node.customUrl}/`)) {
          return 600 + node.customUrl.length;
        }
        return 0;
      })();
      const entityHit = node.entityName && entitySlug && node.entityName === entitySlug;
      const score = customScore || (entityHit ? 700 + node.id.length : 0);

      if (score > bestScore) {
        bestPath = path;
        bestScore = score;
      }
      if (node.children.length) visit(node.children, path);
    }
  };

  visit(nodes, []);
  return bestPath;
}
